import React from "react";

export const textOverflow = (fullText, limit) => {
  if (fullText === undefined || fullText === null) {
    return "";
  }
  return fullText.length > limit ? (
    <span title={fullText}>{fullText.substring(0, limit).concat("...")}</span>
  ) : (
    fullText
  );
};
